
import React from 'react';
import { GlobalStyle } from './styles/globalStyles';
import { Header } from './components/Header';
import { Banner } from './components/Banner';
import { VideoSection } from './components/VideoSection';
import { Download } from './components/Download';
import { Footer } from './components/Footer';


const App: React.FC = () => {

  return (
    <>
      <GlobalStyle />
      <Header />
      <main>
        <Banner />
        <VideoSection />
        <Download />
      </main>
      <Footer />
    </>
  );
};

export default App;